import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode("선물하기")
const _hoisted_3 = {
  id: "content",
  class: "content"
}
const _hoisted_4 = { class: "fill_out_order_detail_area" }
const _hoisted_5 = { class: "box_write" }
const _hoisted_6 = { class: "item_write" }
const _hoisted_7 = { class: "box_img_write" }
const _hoisted_8 = { class: "write_message" }
const _hoisted_9 = /*#__PURE__*/_createVNode("label", {
  for: "writemessage",
  class: "blind"
}, "메시지 입력", -1)
const _hoisted_10 = { class: "txt_count" }
const _hoisted_11 = { class: "box_recipient" }
const _hoisted_12 = { class: "tit" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode("받는 사람 ")
const _hoisted_14 = {
  key: 0,
  class: "unit"
}
const _hoisted_15 = { class: "list_recipient" }
const _hoisted_16 = { class: "recipients" }
const _hoisted_17 = { class: "count" }
const _hoisted_18 = /*#__PURE__*/_createVNode("span", { class: "ico_del" }, "지우기", -1)
const _hoisted_19 = { class: "box_order_card" }
const _hoisted_20 = /*#__PURE__*/_createVNode("h2", { class: "tit" }, "주문 정보", -1)
const _hoisted_21 = {
  href: "#",
  class: "card_in"
}
const _hoisted_22 = { class: "thumb" }
const _hoisted_23 = { class: "cont" }
const _hoisted_24 = { class: "name" }
const _hoisted_25 = { class: "price" }
const _hoisted_26 = { class: "order_count" }
const _hoisted_27 = { class: "box_order_amount" }
const _hoisted_28 = { class: "box_total" }
const _hoisted_29 = /*#__PURE__*/_createVNode("strong", { class: "total_title" }, "총 결제 금액", -1)
const _hoisted_30 = { class: "total_price" }
const _hoisted_31 = { class: "num" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode("원")
const _hoisted_33 = { class: "btn_area_wrap" }
const _hoisted_34 = { class: "btn_area" }
const _hoisted_35 = {
  class: "dimmed",
  style: {"display":"block"}
}
const _hoisted_36 = /*#__PURE__*/_createVNode("strong", { class: "txt" }, [
  /*#__PURE__*/_createTextVNode("받는 사람"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" 목록에서 삭제하시겠습니까?")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_header_component = _resolveComponent("header-component")
  const _component_popup_component = _resolveComponent("popup-component")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", {
      id: "wrap",
      class: ["wrap", {app_view: _ctx.isApp}]
    }, [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_header_component, null, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        })
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("div", _hoisted_5, [
            _createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("img", {
                  src: _ctx.product.productImageUrl,
                  class: "img_product",
                  alt: ""
                }, null, 8, ["src"])
              ]),
              _createVNode("div", _hoisted_8, [
                _hoisted_9,
                _withDirectives(_createVNode("textarea", {
                  id: "writemessage",
                  class: "tf_write",
                  rows: "5",
                  maxlength: "100",
                  placeholder: "선물 메세지를 입력해 주세요 (선택)",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.message = $event)),
                  onFocusin: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setTypingMode(true))),
                  onFocusout: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setTypingMode(false))),
                  onKeyup: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.limit && _ctx.limit(...args)))
                }, "\n              ", 544), [
                  [_vModelText, _ctx.message]
                ]),
                _createVNode("span", _hoisted_10, "(" + _toDisplayString(_ctx.messageLength) + "/" + _toDisplayString(_ctx.maxMessageLength) + "자 입력)", 1)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_11, [
            _createVNode("h2", _hoisted_12, [
              _hoisted_13,
              (_ctx.isForPresent)
                ? (_openBlock(), _createBlock("span", _hoisted_14, "(총 " + _toDisplayString(_ctx.receivers.length) + "명)", 1))
                : _createCommentVNode("", true)
            ]),
            _createVNode("ul", _hoisted_15, [
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.receivers, (receiver, index) => {
                return (_openBlock(), _createBlock("li", {
                  class: ["cont_item", {'cont_item2': !_ctx.isForPresent}],
                  key: receiver.phoneNumber
                }, [
                  _createVNode("p", _hoisted_16, _toDisplayString(receiver.displayedName), 1),
                  _createVNode("div", _hoisted_17, [
                    _createVNode("button", {
                      type: "button",
                      class: ["btn_minus", {'is_active': _ctx.isDecreasable(index)}],
                      "data-type": "minus",
                      onClick: _withModifiers(($event: any) => (_ctx.decreaseGiftCount(index)), ["prevent"]),
                      disabled: !_ctx.isDecreasable(index)
                    }, null, 10, ["onClick", "disabled"]),
                    _createVNode("input", {
                      type: "text",
                      class: "inp_small",
                      value: receiver.ticketCount,
                      readonly: ""
                    }, null, 8, ["value"]),
                    _createVNode("button", {
                      type: "button",
                      class: ["btn_plus", {'is_active disabled': _ctx.isIncreasable(index)}],
                      "data-type": "plus",
                      onClick: _withModifiers(($event: any) => (_ctx.increaseGiftCount(index)), ["prevent"]),
                      disabled: !_ctx.isIncreasable(index)
                    }, null, 10, ["onClick", "disabled"])
                  ]),
                  (_ctx.isForPresent)
                    ? (_openBlock(), _createBlock("button", {
                        key: 0,
                        type: "button",
                        class: "btn_del",
                        onClick: ($event: any) => (_ctx.askIfDelete(index))
                      }, [
                        _hoisted_18
                      ], 8, ["onClick"]))
                    : _createCommentVNode("", true)
                ], 2))
              }), 128))
            ])
          ]),
          _createVNode("div", _hoisted_19, [
            _hoisted_20,
            _createVNode("a", _hoisted_21, [
              _createVNode("span", _hoisted_22, [
                _createVNode("img", {
                  src: _ctx.product.productImageUrl,
                  alt: ""
                }, null, 8, ["src"])
              ]),
              _createVNode("div", _hoisted_23, [
                _createVNode("strong", _hoisted_24, _toDisplayString(_ctx.product.productName), 1),
                _createVNode("p", _hoisted_25, _toDisplayString(_ctx.product.commaSalePrice) + "원", 1),
                _createVNode("span", _hoisted_26, "수량 : " + _toDisplayString(_ctx.sumOfGiftCount) + "개", 1)
              ])
            ])
          ]),
          _createVNode("div", _hoisted_27, [
            _createVNode("div", _hoisted_28, [
              _hoisted_29,
              _createVNode("span", _hoisted_30, [
                _createVNode("span", _hoisted_31, _toDisplayString(_ctx.commaTotalPrice), 1),
                _hoisted_32
              ])
            ])
          ]),
          _withDirectives(_createVNode("div", _hoisted_33, [
            _createVNode("div", _hoisted_34, [
              _createVNode("button", {
                type: "button",
                class: "btn btn_full",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.goToOrderSheet && _ctx.goToOrderSheet(...args)))
              }, "주문하기 ")
            ])
          ], 512), [
            [_vShow, !_ctx.isTypingMode]
          ])
        ])
      ])
    ], 2),
    _withDirectives(_createVNode("div", _hoisted_35, null, 512), [
      [_vShow, _ctx.showDeletingPopup]
    ]),
    _withDirectives(_createVNode(_component_popup_component, {
      onConfirm: _ctx.confirmDeletion,
      showCancelButton: true
    }, {
      default: _withCtx(() => [
        _hoisted_36
      ]),
      _: 1
    }, 8, ["onConfirm"]), [
      [_vShow, _ctx.showDeletingPopup]
    ])
  ], 64))
}